<template>
  <v-card elevation="0" class="department-billing-card">
    <v-card-text>
      <div class="department-billing-heading">
        <div>
          <div class="text-subtitle-1 font-weight-bold">Monthly tuition billing</div>
          <div class="caption grey--text">Choose which months this department charges tuition. The fee is set above; billing day and payment routing come from institute settings.</div>
        </div>
        <v-switch :input-value="rule.enabled" inset hide-details label="Enabled" class="mt-0" @change="update('enabled', $event)" />
      </div>

      <v-expand-transition>
        <div v-if="rule.enabled" class="department-billing-fields">
          <v-alert text color="warning" icon="mdi-pause-circle-outline" class="mb-5">
            Saving this plan will not create or collect invoices while automatic billing is paused.
          </v-alert>
          <div class="month-label">Months to bill</div>
          <div class="month-grid">
            <v-btn
              v-for="month in monthOptions"
              :key="month.value"
              small
              depressed
              :outlined="!rule.months.includes(month.value)"
              :color="rule.months.includes(month.value) ? 'primary' : undefined"
              @click="toggleMonth(month.value)"
            >{{ month.short }}</v-btn>
          </div>
          <div class="caption grey--text mt-3">Unselected months will not receive a department tuition line.</div>
        </div>
      </v-expand-transition>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "DepartmentBillingPlan",
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {
      monthOptions: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
      ].map((text, index) => ({ text, short: text.slice(0, 3), value: index + 1 })),
    };
  },
  computed: {
    rule() {
      return Object.assign({ enabled: false, months: [] }, this.value);
    },
  },
  methods: {
    update(field, value) {
      this.$emit("input", Object.assign({}, this.rule, { [field]: value }));
    },
    toggleMonth(month) {
      const months = this.rule.months.includes(month)
        ? this.rule.months.filter(value => value !== month)
        : this.rule.months.concat(month).sort((a, b) => a - b);
      this.update("months", months);
    },
  },
};
</script>

<style scoped>
.department-billing-card { border: 1px solid #dce8dc; border-radius: 10px !important; }
.department-billing-heading { display: flex; align-items: center; justify-content: space-between; gap: 18px; }
.department-billing-fields { margin-top: 20px; padding-top: 20px; border-top: 1px solid #edf1ed; }
.month-label { margin: 12px 0 9px; color: #344054; font-size: 13px; font-weight: 600; }
.month-grid { display: grid; grid-template-columns: repeat(6, minmax(62px, 1fr)); gap: 8px; }
.month-grid .v-btn { text-transform: none; }
@media (max-width: 600px) {
  .department-billing-heading { align-items: flex-start; flex-direction: column; }
  .month-grid { grid-template-columns: repeat(3, 1fr); }
}
</style>
